export default __webpack_public_path__ + "static/SuisseIntl-Medium-eff9e07c3a406be5bc8ea1b61140eb75.woff";